import Vue from 'vue'
import VueRouter from 'vue-router'
import Gate from '../gate'

Vue.use(VueRouter)
window.gate = new Gate(window.user)

if (gate.can('Update Information')) {
    var defaultProfile = '/profile/update-info'
} else if (gate.can('Generate New Key')) {
    var defaultProfile = '/profile/generate-key'
} else {
    var defaultProfile = '/profile/change-password'
}

var defaultSettings = '/settings/signatories'

const routes = [
    {
        component: () => import('../components/dashboard/dashboard.vue'),
        path: '/',
        name: 'Dashboard',
        meta: { Dashboard: true }
    },
    {
        component: () => import('../components/inquiry/inquiry.vue'),
        path: '/inquiry',
        name: 'Inquiry',
        meta: { Inquiry: true }
    },
    {
        component: () => import('../components/inquiry/cashier-collection.vue'),
        path: '/cashier-colls-admin',
        name: 'CashierCollection',
        meta: { CashierCollection: true }
    },
    {
        component: () => import('../components/reports/GeneralSummary.vue'),
        path: '/gen-summ',
        name: 'GeneralSummary',
        meta: { GeneralSummary: true }
    },
    {
        component: () => import('../components/reports/CsmScope.vue'),
        path: '/csm-scope',
        name: 'CsmScope',
        meta: { CsmScope: true }
    },
    {
        component: () => import('../components/reports/Rpt.vue'),
        path: '/rpt',
        name: 'RPT',
        meta: { RPT: true }
    },
    {
        component: () => import('../components/rpt/dataMatching.vue'),
        path: '/rpt-data-matching',
        name: 'DataMatching',
        meta: { DataMatching: true }
    },
    {
        component: () => import('../components/trans/trans.vue'),
        path: '/trans',
        name: 'Transactions',
        meta: { Transactions: true }
    },
    {
        component: () => import('../components/trans/bulk_trans.vue'),
        path: '/Encoded-trans',
        name: 'Encoded Transactions',
        meta: { BulkTransactions: true }
    },
    {
        component: () => import('../components/trans/details.vue'),
        path: '/tran-details/:id/:type/:or_type',
        name: 'Transaction Details',
        meta: { TranDetails: true }
    },
    {
        component: () => import('../components/cancelled-or/details.vue'),
        path: '/cancelled-or-details/:id/:type/:or_type',
        name: 'Cancelled OR Details',
        meta: { CancelledORDetails: true }
    },
    {
        component: () => import('../components/trans/bulk_trans_details.vue'),
        path: '/Encoded-tran-details/:id',
        name: 'Encoded Transaction Details',
        meta: { BulkTranDetails: true }
    },
    {
        component: () => import('../components/cashier2/cashier.vue'),
        path: '/cashier',
        name: 'Cashier',
        meta: { Cashier: true }
    },
    {
        component: () => import('../components/cashier2/paymentOrder.vue'),
        path: '/payment-order',
        name: 'PaymentOrder',
        meta: { PaymentOrder: true }
    },
    {
        component: () => import('../components/cashier2/topCashier.vue'),
        path: '/top-cashier',
        name: 'TopCashier',
        meta: { PaymentOrder: true }
    },
    {
        component: () => import('../components/cashier2/check/check.vue'),
        path: '/check',
        name: 'Check',
        meta: { Check: true }
    },
    {
        component: () => import('../components/cashier2/ctcInd.vue'),
        path: '/ctc-ind',
        name: 'CtcInd',
        meta: { CtcInd: true }
    },
    {
        component: () => import('../components/cashier2/ctcCorp.vue'),
        path: '/ctc-corp',
        name: 'CtcCorp',
        meta: { CtcCorp: true }
    },
    {
        component: () => import('../components/cashier2/multiPayment.vue'),
        path: '/multi-payment',
        name: 'Multiple Payment',
        meta: { multiPayment: true }
    },
    {
        component: () => import('../components/cashier2/sht/sht.vue'),
        path: '/sht-list',
        name: 'Sht',
        meta: { Sht: true }
    },
    {
        component: () => import('../components/cashier2/ctc/ctc.vue'),
        path: '/ctc-list',
        name: 'CTC',
        meta: { CTC: true }
    },
    {
        component: () => import('../components/cashier2/bplo/bplo.vue'),
        path: '/bplo-list',
        name: 'BPLO',
        meta: { BPLO: true }
    },
    {
        component: () => import('../components/collections/categorize.vue'),
        path: '/coll-accts',
        name: 'Collection Accounts',
        meta: { CollectionAccounts: true }
    },
    {
        component: () => import('../components/collections/natureOfTax.vue'),
        path: '/nature-of-tax',
        name: 'Report 60',
        meta: { NatureOfTax: true }
    },
    {
        component: () =>
            import('../components/collections/summCollPerAcct.vue'),
        path: '/summ-of-coll-per-acct',
        name: 'Summary of Collection Per Account',
        meta: { summCollPerAcct: true }
    },
    {
        component: () => import('../components/collections/summColl.vue'),
        path: '/summ-of-coll',
        name: 'Summary of Collections',
        meta: { summColl: true }
    },
    {
        component: () => import('../components/collections/Sma.vue'),
        path: '/main-accounts',
        name: 'SMA',
        meta: { SMA: true }
    },
    {
        component: () => import('../components/collections/GFRCD.vue'),
        path: '/gf-rcd-trust-sef',
        name: 'GF-RCD/TRUST/SEF',
        meta: { GFRCD: true }
    },
    {
        component: () => import('../components/collections/CsmServices.vue'),
        path: '/csm-services',
        name: 'CSM Services',
        meta: { CsmServices: true }
    },
    {
        component: () => import('../components/employee/employee.vue'),
        path: '/employees',
        name: 'EmployeeList',
        meta: { EmployeeList: true }
    },
    {
        component: () => import('../components/checks/checks.vue'),
        path: '/check-list',
        name: 'Checks',
        meta: { Checks: true }
    },
    {
        component: () => import('../components/remittance/remittance.vue'),
        path: '/remittance',
        name: 'Remittance',
        meta: { Remittance: true }
    },
    {
        component: () => import('../components/swapping/OrSwapping.vue'),
        path: '/or-swapping',
        name: 'OrSwapping',
        meta: { OrSwapping: true }
    },
    {
        component: () => import('../components/held-or/held-or.vue'),
        path: '/held-or',
        name: 'HeldOR',
        meta: { HeldOR: true }
    },
    {
        component: () => import('../components/cancelled-or/cancelled-or.vue'),
        path: '/cancelled-or',
        name: 'CancelledOR',
        meta: { CancelledOR: true }
    },
    {
        component: () => import('../components/payment-adjustments/paymentAdjustments.vue'),
        path: '/payment-adjustments',
        name: 'PaymentAdjustments',
        meta: { PaymentAdjustments: true }
    },
    {
        component: () => import('../components/reports/onlinePayments.vue'),
        path: '/online-payments',
        name: 'OnlinePayments',
        meta: { OnlinePayments: true }
    },
    {
        component: () => import('../components/failed-jobs/failedJobs.vue'),
        path: '/failed-jobs',
        name: 'FailedJobs',
        meta: { FailedJobs: true }
    },
    {
        component: () => import('../components/or/or.vue'),
        path: '/or',
        name: 'OR',
        meta: { OR: true }
    },
    {
        component: () => import('../components/brgy/Barangays.vue'),
        path: '/brgys',
        name: 'Barangays',
        meta: { Barangays: true }
    },
    {
        component: () => import('../components/users/users.vue'),
        path: '/user-mgt',
        name: 'UserManagement',
        meta: { UserManagement: true }
    },
    {
        component: () => import('../components/logs/logs.vue'),
        path: '/logs',
        name: 'Logs',
        meta: { Logs: true }
    },
    {
        component: () => import('../components/depts/depts.vue'),
        path: '/department-list',
        name: 'Departments',
        meta: { Departments: true }
    },
    {
        component: () => import('../components/profile/profile.vue'),
        path: '/profile',
        redirect: defaultProfile,
        name: 'Profile',
        meta: { Profile: true },
        children: [
            {
                path: 'update-info',
                component: () =>
                    import('../components/profile/update_info.vue'),
                meta: { UpdateInfo: true }
            },
            {
                path: 'change-password',
                component: () =>
                    import('../components/profile/change_password.vue')
            },
            {
                path: 'generate-key',
                component: () =>
                    import('../components/profile/generate_new_key.vue'),
                meta: { GenerateKey: true }
            }
        ]
    },
    {
        component: () =>
            import('../components/rolesAndPermissions/rolesAndPermissions.vue'),
        path: '/roles-permissions',
        name: 'RolesAndPermissions',
        meta: { RolesAndPermissions: true }
    },
    {
        component: () => import('../components/holidays/holidays.vue'),
        path: '/holidays',
        name: 'Holidays',
        meta: { Holidays: true }
    },
    {
        // Safe as a page path: no Laravel GET route uses /announcements. The
        // data routes are get-announcement and active-announcements for
        // exactly this reason. A page path that matches a GET route makes a
        // browser refresh return raw JSON instead of the app.
        component: () => import('../components/announcements/announcements.vue'),
        path: '/announcements',
        name: 'Announcements',
        meta: { Announcements: true }
    },
    {
        component: () => import('../components/settings/settings.vue'),
        path: '/settings',
        name: 'Settings',
        redirect: defaultSettings,
        meta: { Settings: true },
        children: [
            {
                path: 'signatories',
                component: () =>
                    import('../components/settings/signatories.vue')
            },
            {
                path: 'rcd',
                component: () =>
                    import('../components/settings/rcd.vue')
            },
        ]
    },
    {
        component: () => import('../components/reports/history/rcd.vue'),
        path: '/report-rcd',
        name: 'RCD',
        meta: { RCD: true }
    },
    {
        component: () => import('../components/reports/history/history.vue'),
        path: '/report-history',
        name: 'History',
        meta: { History: true }
    },
    {
        component: () => import('../components/dashboard/dashboard.vue'),
        path: '*',
        meta: { Others: true }
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.Dashboard)) {
        if (gate.can('View Dashboard Analytics')) {
            next()
        } else {
            if (
                gate.can('Report 60') ||
                gate.can('Summary Collection') ||
                gate.can('Summary of Collection Per Account') ||
                gate.can('Summary of Main Accounts') ||
                gate.can('GF-RCD/TRUST/SEF') ||
                gate.can('RCD') ||
                gate.can('RGR') ||
                gate.can('RAAF') ||
                gate.can('RAAF (Amount and Cancelled OR)') ||
                gate.can('CRAAF') ||
                gate.can('OR Acceptance') ||
                gate.can('Abstract')
            ) {
                next('/gen-summ')
            } else if (gate.can('Inquiry') || gate.can('Cashier Collections')) {
                next('/inquiry')
            } else if (gate.can('Cashier Collections')) {
                next('/cashier-colls-admin')
            } else if (
                gate.can('Real Property Tax Collection') ||
                gate.can('Advance Real Property Tax Collection') ||
                gate.can('Barangay Shares') ||
                gate.can('Advance Barangay Shares') ||
                gate.can('Report on RPT (Basic / SEF)')
            ) {
                next('/rpt')
            } else if (gate.can('RPT Data Sync')) {
                next('/rpt-data-matching')
            } else if (gate.can('Tax Order Payment')) {
                next('/payment-order')
            } else if (gate.can('Create Transaction')) {
                next('/cashier')
            } else if (gate.can('Check Payment')) {
                next('/check')
            } else if (gate.can('CTC Individual')) {
                next('/ctc-ind')
            } else if (gate.can('CTC Corporation')) {
                next('/ctc-corp')
            } else if (gate.can('Encoding')) {
                next('/multi-payment')
            } else if (gate.can('View SHT List')) {
                next('/sht-list')
            } else if (gate.can('View CTC List')) {
                next('/ctc-list')
            } else if (gate.can('View BPLO List')) {
                next('/bplo-list')
            } else if (
                gate.can('View Transaction List') ||
                gate.can('View Transaction List Admin')
            ) {
                next('/trans')
            } else if (
                gate.can('View Encoded Transaction List') ||
                gate.can('View Encoded Transaction List Admin')
            ) {
                next('/Encoded-trans')
            } else if (gate.can('View Transaction Details')) {
                next('/tran-details/:id/:type/:or_type')
            } else if (gate.can('View Encoded Transaction Details')) {
                next('/Encoded-tran-details/:id')
            } else if (gate.can('View Collection Names')) {
                next('/coll-accts')
            } else if (gate.can('View Report 60 List')) {
                next('/nature-of-tax')
            } else if (gate.can('View Summary of Collections Per Account')) {
                next('/summ-of-coll-per-acct')
            } else if (gate.can('View Summary of Collection List')) {
                next('/summ-of-coll')
            } else if (gate.can('View Main Account List')) {
                next('/main-accounts')
            } else if (gate.can('View GF-RCD/TRUST/SEF List')) {
                next('/gf-rcd-trust-sef')
            } else if (gate.can('View Employee List')) {
                next('/employees')
            } else if (
                gate.can('View Remittance') ||
                gate.can('View Remittance Admin')
            ) {
                next('/remittance')
            } else if (
                gate.can('View OR Swapping') ||
                gate.can('View OR Swapping Admin')
            ) {
                next('/or-swapping')
            } else if (
                gate.can('View Held OR List') ||
                gate.can('View Held OR List Admin')
            ) {
                next('/held-or')
            } else if (
                gate.can('View Cancelled OR List') ||
                gate.can('View Cancelled OR List Admin')
            ) {
                next('/cancelled-or')
            } else if (gate.can('View OR List')) {
                next('/or')
            } else if (gate.can('View Barangay List')) {
                next('/brgys')
            } else if (gate.can('View User List')) {
                next('/user-mgt')
            } else if (gate.can('View Log List')) {
                next('/logs')
            } else if (gate.can('View Department List')) {
                next('/department-list')
            } else if (gate.can('View Role List')) {
                next('/roles-permissions')
            } else if (gate.can('View Holidays')) {
                next('/holidays')
            } else if (gate.can('Settings')) {
                next('/settings')
            } else if (gate.can('View RCD List') || gate.can('View Own RCD List')) {
                next('/report-rcd')
            } else if (gate.can('View Report History List')) {
                next('/report-history')
            } else {
                next('/profile')
            }
        }
    } else if (to.matched.some((record) => record.meta.GeneralSummary)) {
        if (
            gate.can('Report 60') ||
            gate.can('Summary Collection') ||
            gate.can('Summary of Collection Per Account') ||
            gate.can('Summary of Main Accounts') ||
            gate.can('GF-RCD/TRUST/SEF') ||
            gate.can('RCD') ||
            gate.can('RGR') ||
            gate.can('RAAF') ||
            gate.can('RAAF (Amount and Cancelled OR)') ||
            gate.can('CRAAF') ||
            gate.can('OR Acceptance') ||
            gate.can('Abstract')
        ) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.CsmScope)) {
        if (gate.can('CSM Report')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.RPT)) {
        if (
            gate.can('Real Property Tax Collection') ||
            gate.can('Advance Real Property Tax Collection') ||
            gate.can('Barangay Shares') ||
            gate.can('Advance Barangay Shares') ||
            gate.can('Report on RPT (Basic / SEF)')
        ) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.DataMatching)) {
        if (gate.can('RPT Data Sync')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.CashierCollection)) {
        if (gate.can('Cashier Collections')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.Inquiry)) {
        if (gate.can('Inquiry') || gate.can('Cashier Collections')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.Cashier)) {
        if (gate.can('Create Transaction')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.PaymentOrder)) {
        if (gate.can('Tax Order Payment')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.Check)) {
        if (gate.can('Check Payment')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.CtcInd)) {
        if (gate.can('CTC Individual')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.CtcCorp)) {
        if (gate.can('CTC Corporation')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.multiPayment)) {
        if (gate.can('Encoding')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.Sht)) {
        if (gate.can('View SHT List')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.CTC)) {
        if (gate.can('View CTC List')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.BPLO)) {
        if (gate.can('View BPLO List')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.Transactions)) {
        if (
            gate.can('View Transaction List') ||
            gate.can('View Transaction List Admin')
        ) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.TranDetails)) {
        if (gate.can('View Transaction Details')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.CancelledORDetails)) {
        if (
            gate.can('View Cancelled OR List') ||
            gate.can('View Cancelled OR List Admin')
        ) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.Held)) {
        if (
            gate.can('View Held OR List') ||
            gate.can('View Held OR List Admin')
        ) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.BulkTranDetails)) {
        if (gate.can('View Encoded Transaction Details')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.CollectionAccounts)) {
        if (gate.can('View Collection Names')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.NatureOfTax)) {
        if (gate.can('View Report 60 List')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.summCollPerAcct)) {
        if (gate.can('View Summary of Collections Per Account')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.summColl)) {
        if (gate.can('View Summary of Collection List')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.SMA)) {
        if (gate.can('View Main Account List')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.GFRCD)) {
        if (gate.can('View GF-RCD/TRUST/SEF List')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.CsmServices)) {
        if (gate.can('View CSM Service List')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.EmployeeList)) {
        if (gate.can('View Employee List')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.Remittance)) {
        if (gate.can('View Remittance') || gate.can('View Remittance Admin')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.OrSwapping)) {
        if (
            gate.can('View OR Swapping') ||
            gate.can('View OR Swapping Admin')
        ) {
            next()
        } else {
            next('/or-swapping')
        }
    } else if (to.matched.some((record) => record.meta.CancelledOR)) {
        if (
            gate.can('View Cancelled OR List') ||
            gate.can('View Cancelled OR List Admin')
        ) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.PaymentAdjustments)) {
        if (
            gate.can('Request Payment Adjustment') ||
            gate.can('Approve Payment Adjustment')
        ) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.OnlinePayments)) {
        if (gate.can('View Online Payments')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.OR)) {
        if (gate.can('View OR List')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.Barangays)) {
        if (gate.can('View Barangay List')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.UserManagement)) {
        if (gate.can('View User List')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.Logs)) {
        if (gate.can('View Log List')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.Departments)) {
        if (gate.can('View Department List')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.Profile)) {
        if (gate.can('Update Information') || gate.can('Generate New Key')) {
            if (to.matched.some((record) => record.meta.UpdateInfo)) {
                if (gate.can('Update Information')) {
                    next()
                } else {
                    next('/')
                }
            } else if (to.matched.some((record) => record.meta.GenerateKey)) {
                if (gate.can('Generate New Key')) {
                    next()
                } else {
                    next('/')
                }
            } else {
                next()
            }
        } else {
            next()
        }
    } else if (to.matched.some((record) => record.meta.RolesAndPermissions)) {
        if (gate.can('View Role List')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.Holidays)) {
        if (gate.can('View Holidays')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.Announcements)) {
        if (gate.can('View Announcements')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.Settings)) {
        if (gate.can('Settings')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.RCD)) {
        if (gate.can('View RCD List') || gate.can('View Own RCD List')) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some((record) => record.meta.History)) {
        if (gate.can('View Report History List')) {
            next()
        } else {
            next('/')
        }
    } else {
        next()
    }
})

export default router
